<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">
   
   <sidebar v-on:toggle="$teras.event.emit('sidebarToggle')" >
      <div slot="sidebar" style="color:#fff;width:100%;line-height:2.4rem;font-size:1.6rem;text-align:center;">Barcelona, 19-23 MAY 2019</div>
   </sidebar>

   <div class="header-top " >
      <site-header></site-header>
      <site-navbar v-if="$teras.app.device=='desktop'"></site-navbar>
   </div>

   <div class="app-main row">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->
   
   
   
   <div class="app-footer yo-text-n">
      <site-footer v-if="!(['savethedate'].indexOf($route.name) > -1)"></site-footer>
   </div>   


   <div v-if="$teras.app.ready && cookie==true && !$teras.exist('cookie')" class="yo-fixed-bottom yo-bg-transparency-black white yo-valign-text-center" style="left:0;height:180px;right:0;padding:0 40px;" >
      <div  class="yo-align-right"><i class="material-icons yo-pointer" @click="$teras.save('cookie',false);cookie=false">clear</i></div>

      We use cookies to help you use the site and optimize your browsing experience. By continuing to visit the site, the user accepts the use of cookies.
      <br /><br /><br />
      <div class="row">
        <a class="col s3 offset-s2 yo-pointer yo-align-center" style="border:1px solid #fff;line-height:40px;display:block;color:#fff;" target="_blank" href="/2019/documenti/Cookie.pdf">FIND MORE</a>
        <div class="col s3 offset-s2 yo-pointer yo-align-center" style="border:1px solid #fff;line-height:40px;" @click="$teras.save('cookie',false);cookie=false">I ACCEPT</div>
      </div>
    </div>
   
  <!--
    Il nostro sito web utilizza i cookie per assicurarti la miglior esperienza di navigazione. Se desideri maggiori informazioni sui cookie e su come controllarne l'abilitazione con le impostazioni del browser consulta la nostra Cookie Policy
  -->
  
</div> <!-- end app -->
</template>

<script>
import sidebar from './components/Sidebar'
import siteHeader from './components/Site-header.vue'
import siteNavbar from './components/Site-navbar.vue'
import siteFooter from './components/Site-footer.vue'
export default {
   name: 'app',
   components: {
      sidebar,
      siteHeader,
      siteNavbar,
      siteFooter
   },
   data() {
    return {
      dialogVisible: false,
      cookie: true
    }
  }

  
}
</script>

<style>
</style>
